import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkerUsersLookUpComponent } from './worker-users-look-up.component';
import { FormsModule } from '@angular/forms';
import { NgSelectModule } from '@ng-select/ng-select';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    NgSelectModule
  ],
  declarations: [WorkerUsersLookUpComponent],
  exports: [WorkerUsersLookUpComponent],
})
export class WorkerUsersLookUpModule { }
